import React from 'react'

import { Check } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Button } from '@/shared/components/atoms/Button'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from '@/shared/components/molecules/Dialog/dialog'

interface SubscriptionSuccessModalProps {
	open: boolean
}

export const SubscriptionSuccessModal: React.FC<
	SubscriptionSuccessModalProps
> = ({ open }) => {
	const { t } = useTranslation('common')
	const navigate = useNavigate()

	const handleGoHome = () => {
		navigate('/')
	}

	return (
		<Dialog open={open} onOpenChange={() => {}}>
			<DialogContent
				className="sm:max-w-md bg-card border-border dark:bg-card"
				onInteractOutside={(e) => e.preventDefault()}
				onEscapeKeyDown={(e) => e.preventDefault()}
				showCloseButton={false}
			>
				<div className="flex flex-col items-center text-center p-6">
					{/* Icon Container */}
					<div className="h-16 w-16 bg-muted/20 rounded-2xl flex items-center justify-center mb-6">
						<div className="h-8 w-8 bg-white rounded-full flex items-center justify-center shadow-sm">
							<Check className="h-5 w-5 text-black stroke-[3]" />
						</div>
					</div>

					<DialogHeader>
						<DialogTitle className="text-2xl font-semibold mb-2 text-center">
							{t('subscribe.success.title')}
						</DialogTitle>
						<DialogDescription className="text-base text-muted-foreground max-w-sm mx-auto">
							{t('subscribe.success.description')}
						</DialogDescription>
					</DialogHeader>

					<DialogFooter className="w-full mt-8 sm:justify-center">
						<Button
							className="w-full sm:w-auto min-w-[200px] rounded-full bg-white text-black hover:bg-gray-200"
							size="lg"
							onClick={handleGoHome}
						>
							{t('subscribe.success.go_to_dashboard')}
						</Button>
					</DialogFooter>
				</div>
			</DialogContent>
		</Dialog>
	)
}
